// @flow

import type { EmployeesState } from "@modules/employee/reducer";
import { transformSort } from "@transformers/sort";
import { initialState } from "../index";
import { startRequest, finishRequest } from "@store/utils";

export const setLoading = (state: EmployeesState) => () => ({
  ...state,
  employee: {
    ...state.employee,
    medicalDetails: {
      ...startRequest(state.employee.medicalDetails),
    },
  },
});

export const setLoaded = (state: EmployeesState) => () => ({
  ...state,
  employee: {
    ...state.employee,
    medicalDetails: {
      ...finishRequest(state.employee.medicalDetails),
    },
  },
});

export const onToggleAddVaccinationModal = (state: EmployeesState) => () => {
  state.employee.medicalDetails.modals.addVaccination.visible = !state.employee.medicalDetails
    .modals.addVaccination.visible;
  return state;
};
export const onToggleDeleteVaccinationModal = (state: EmployeesState) => ({ payload }: Object) => {
  state.employee.medicalDetails.modals.deleteVaccination = {
    ...payload,
    visible: !state.employee.medicalDetails.modals.deleteVaccination.visible,
  };
  return state;
};
export const onGetVaccineTypesSuccess = (state: EmployeesState) => ({ payload }: Object) => {
  state.employee.medicalDetails.modals.addVaccination.vaccinationTypes = payload.content;
  return state;
};

export const onToggleAddMedicationModal = (state: EmployeesState) => ({ payload }: Object) => {
  state.employee.medicalDetails.modals.addMedication.visible = payload;
  return state;
};

export const onGetAddMedicationError = (state: EmployeesState) => ({ payload }: Object) => {
  state.error = payload;
  state.employee.medicalDetails.modals.addMedication.visible = false;
  return state;
};

export const onToggleAddAllergyModal = (state: EmployeesState) => ({ payload }: Object) => {
  state.employee.medicalDetails.modals.addAllergy.visible = payload;
  return state;
};

export const onGetAddAllergyError = (state: EmployeesState) => ({ payload }: Object) => {
  state.error = payload;
  state.employee.medicalDetails.modals.addAllergy.visible = false;
  return state;
};

export const onToggleAddMedicalHistoryItemModal = (state: EmployeesState) => ({
  payload,
}: Object) => {
  state.employee.medicalDetails.modals.addMedicalHistoryItem.visible = payload;
  return state;
};

export const onGetAddMedicalHistoryItemError = (state: EmployeesState) => ({ payload }: Object) => {
  state.error = payload;
  state.employee.medicalDetails.modals.addMedicalHistoryItem.visible = false;
  finishRequest(state.employee.medicalDetails);
  return state;
};

export const onToggleRemoveMedicationModal = (state: EmployeesState) => ({ payload }: Object) => {
  state.employee.medicalDetails.modals.removeMedication.visible = payload.visible;
  state.employee.medicalDetails.modals.removeMedication.medicationId = payload.medicationId;
  return state;
};

export const onGetRemoveMedicationError = (state: EmployeesState) => ({ payload }: Object) => {
  state.error = payload;
  state.employee.medicalDetails.modals.removeMedication.visible = false;
  state.employee.medicalDetails.modals.removeMedication.medicationId = null;
  return state;
};

export const onToggleRemoveAllergyModal = (state: EmployeesState) => ({ payload }: Object) => {
  state.employee.medicalDetails.modals.removeAllergy.visible = payload.visible;
  state.employee.medicalDetails.modals.removeAllergy.allergyId = payload.allergyId;
  return state;
};

export const onGetRemoveAllergyError = (state: EmployeesState) => ({ payload }: Object) => {
  state.error = payload;
  state.employee.medicalDetails.modals.removeAllergy.visible = false;
  state.employee.medicalDetails.modals.removeAllergy.allergyId = null;
  return state;
};

export const onGetEmployeeMedicationsSuccess = (state: EmployeesState) => ({ payload }: Object) => {
  state.error = null;
  state.employee.medicalDetails.medications = payload;
  finishRequest(state.employee.medicalDetails);
  return state;
};

export const onGetEmployeeMedicationsError = (state: EmployeesState) => ({ payload }: Object) => {
  state.error = payload;
  state.employee.medicalDetails.medications.content = [];
  finishRequest(state.employee.medicalDetails);
  return state;
};

export const onGetEmployeeAllergiesSuccess = (state: EmployeesState) => ({ payload }: Object) => {
  state.error = null;
  state.employee.medicalDetails.allergies = payload;
  finishRequest(state.employee.medicalDetails);
  return state;
};

export const onGetEmployeeVaccinations = (state: EmployeesState) => () => {
  state.employee.medicalDetails.vaccinations = initialState.employee.medicalDetails.vaccinations;
  return setLoading(state)();
};

export const onGetEmployeeVaccinationsSuccess = (state: EmployeesState) => ({
  payload,
}: Object) => {
  state.employee.medicalDetails.vaccinations = payload;
  finishRequest(state.employee.medicalDetails);
  return state;
};
export const onGetEmployeeVaccinationsError = (state: EmployeesState) => ({ payload }: Object) => {
  state.error = payload;
  finishRequest(state.employee.medicalDetails);
  return state;
};

export const onGetEmployeeAllergiesError = (state: EmployeesState) => ({ payload }: Object) => {
  state.error = payload;
  state.employee.medicalDetails.allergies.content = [];
  finishRequest(state.employee.medicalDetails);
  return state;
};

export const onGetEmployeeMedicalHistorySuccess = (state: EmployeesState) => ({
  payload,
}: Object) => {
  state.error = null;
  state.employee.medicalDetails.medicalHistory = payload;
  finishRequest(state.employee.medicalDetails);
  return state;
};

export const onGetEmployeeMedicalHistoryError = (state: EmployeesState) => ({
  payload,
}: Object) => {
  state.error = payload;
  state.employee.medicalDetails.medicalHistory.content = [];
  finishRequest(state.employee.medicalDetails);
  return state;
};

export const onSetMedicationSchema = (state: EmployeesState) => ({ payload }: Object) => {
  state.employee.medicalDetails.schema.medication = payload;
  finishRequest(state.employee.medicalDetails);
  return state;
};

export const onSetAllergySchema = (state: EmployeesState) => ({ payload }: Object) => {
  state.employee.medicalDetails.schema.allergy = payload;
  finishRequest(state.employee.medicalDetails);
  return state;
};

export const onSetMedicalHistorySchema = (state: EmployeesState) => ({ payload }: Object) => {
  state.employee.medicalDetails.schema.medicalHistory = payload;
  finishRequest(state.employee.medicalDetails);
  return state;
};

export const onGetMedicalDetailsChangelogSuccess = (state: EmployeesState) => ({
  payload,
}: Object) => {
  state.error = null;
  state.employee.medicalDetails.changelog.list = payload;
  return state;
};

export const onGetMedicalDetailsChangelogError = (state: EmployeesState) => ({
  payload,
}: Object) => {
  state.error = payload;
  state.employee.medicalDetails.changelog.list =
    initialState.employee.medicalDetails.changelog.list;
  return state;
};

export const onSetEmployeeMedicationSort = (state: EmployeesState) => ({ payload }: Object) => {
  (state.employee.medicalDetails.medications.pagination.sort || {}).orders = transformSort(
    payload.sort,
  );
  return setLoading(state)();
};

export const onSetEmployeeAllergySort = (state: EmployeesState) => ({ payload }: Object) => {
  (state.employee.medicalDetails.allergies.pagination.sort || {}).orders = transformSort(
    payload.sort,
  );
  return setLoading(state)();
};

export const onSetEmployeeMedicalHistorySort = (state: EmployeesState) => ({ payload }: Object) => {
  (state.employee.medicalDetails.medicalHistory.pagination.sort || {}).orders = transformSort(
    payload.sort,
  );
  return setLoading(state)();
};

export const onToggleRemoveMedicalHistoryItemModal = (state: EmployeesState) => ({
  payload,
}: Object) => {
  state.employee.medicalDetails.modals.removeMedicalHistoryItem.visible = payload.visible;
  state.employee.medicalDetails.modals.removeMedicalHistoryItem.medicalHistoryItemId =
    payload.medicalHistoryItemId;
  return state;
};
